import { DateTime, Duration } from "luxon";

/**
 * Transforms an ISO duration string into an ISO time string.
 * For example the input PT1H30M10S results in the output 01:30:10
 *
 * @param {string} duration
 * @returns {string}
 */
export function durationToTime(duration: string): string {
  const durationObj = Duration.fromISO(duration);
  const time = durationObj.toISOTime({ suppressMilliseconds: true });
  if (!time) {
    throw new Error("Unable to parse string " + duration);
  }
  return time;
}

/**
 * Transforms an ISO time string into an ISO duration string.
 * For example the input 01:30:10 results in the output PT01H30M10S
 *
 * @param {string} time
 * @returns {string}
 */
export function durationFromTime(time: string): string {
  const durationObj = Duration.fromISOTime(time);
  const duration = durationObj.toISO();
  if (!duration) {
    throw new Error("Unable to parse string " + time);
  }
  return duration;
}

export function humanReadableDate(date: string): string {
  return DateTime.fromISO(date, { zone: "Europe/London" })
    .setLocale("en")
    .toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS);
}
